var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloudUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2501 31.9991C12.2802 32.0013 10.3787 31.2765 8.90989 29.9637C7.44112 28.6509 6.50838 26.8423 6.29037 24.8844C6.07236 22.9265 6.58441 20.9571 7.72842 19.3533C8.87242 17.7495 10.5679 16.6243 12.4901 16.1931C11.934 13.5993 12.431 10.8907 13.8718 8.66338C15.3127 6.43601 17.5793 4.87224 20.1731 4.31608C22.767 3.75992 25.4755 4.25693 27.7029 5.69777C29.9302 7.13861 31.494 9.40526 32.0501 11.9991H32.2501C34.7301 11.9966 37.1224 12.9156 38.9628 14.5778C40.8032 16.24 41.9603 18.5267 42.2096 20.9941C42.4588 23.4614 41.7823 25.9334 40.3115 27.93C38.8407 29.9267 36.6805 31.3056 34.2501 31.7991M30.2501 25.9991L24.2501 19.9991M24.2501 19.9991L18.2501 25.9991M24.2501 19.9991V43.9991",
    stroke: "#1462B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloudUpload);
export default __webpack_public_path__ + "static/media/ic-cloud-upload.a0179cfccaacc9e9b352bd15aca96fb7.svg";
export { ForwardRef as ReactComponent };